import { useCallback } from 'react'
import { L2Dialog, L2DialogActions, L2DialogContent } from '../l2/L2Dialog'
import { useFormDispatch, useFormSelector } from '../../../redux/formStoreHooks'
import { L4LeaveBehindScanner } from './L4BarcodeScanner'
import { setLeaveBehindDialogOpen } from '../../../redux/formSlice'
import { LeaveBehindConcept } from '@fusion-advantage/formlib'

const L4LeaveBehindDialog = () => {
	const open = useFormSelector(state => state.form.leaveBehindDialogOpen)
	const dispatch = useFormDispatch()
	const handleClose = useCallback(() => {
		dispatch(setLeaveBehindDialogOpen(false))
	}, [dispatch])
	const handleScan = useCallback((value: string) => {
		handleClose()
		return value
	}, [handleClose])
	return (
		<L2Dialog show={open} title="Leave Behind Card" size="min" onClose={handleClose}>
			<L2DialogContent>
				<span>Please scan a new leave behind card now.</span>
			</L2DialogContent>
			<L2DialogActions>
				<L4LeaveBehindScanner
					cid={LeaveBehindConcept.cid}
					onScan={handleScan}
					buttonOnly={true}
				/>
			</L2DialogActions>
		</L2Dialog>
	)
}

export default L4LeaveBehindDialog
